(function () {
	const AUTOPLAY_ENABLED = false; // true karoge to autoplay wapas chalu ho jayega
	const AUTOPLAY_INTERVAL = 7000; // 7 seconds
	const SCROLLBAR_IDLE_DELAY = 6000;
	const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

	function initSlider(slider) {
		const track = slider.querySelector('[data-slider-track]');
		const slides = slider.querySelectorAll('[data-slider-slide]');
		const prevBtn = slider.querySelector('[data-slider-prev]');
		const nextBtn = slider.querySelector('[data-slider-next]');
		const thumb = slider.querySelector('[data-slider-thumb]');
		const scrollbar = slider.querySelector('[data-slider-scrollbar]');
		const count = slides.length;

		if (!track || count <= 1) return;

		let autoplayTimer = null; // har slider instance ka apna independent timer
		let isInView = false;
		let scrollbarHideTimer = null;

		function getSlideWidth() {
			return slides[0].getBoundingClientRect().width || track.clientWidth;
		}

		function getIndex() {
			const w = getSlideWidth();
			if (!w) return 0;
			return Math.round(track.scrollLeft / w);
		}

		function goTo(index, smooth) {
			if (index < 0) index = count - 1;
			if (index >= count) index = 0;
			track.scrollTo({ left: index * getSlideWidth(), behavior: smooth === false ? 'auto' : 'smooth' });
		}

		function updateUI() {
			const index = getIndex();

			if (thumb) {
				const thumbWidthPercent = 100 / count;
				const trackPercent = (100 - thumbWidthPercent) * (index / (count - 1));
				thumb.style.left = trackPercent + '%';
			}

			if (prevBtn) prevBtn.disabled = false;
			if (nextBtn) nextBtn.disabled = false;
		}

		function nextSlide() {
			goTo(getIndex() + 1);
		}

		function startAutoplay() {
			if (!AUTOPLAY_ENABLED) return;
			stopAutoplay();
			autoplayTimer = setInterval(nextSlide, AUTOPLAY_INTERVAL);
		}

		function stopAutoplay() {
			if (autoplayTimer) {
				clearInterval(autoplayTimer);
				autoplayTimer = null;
			}
		}

		// ===== Mobile: scrollbar sirf interaction/touch par temporarily dikhao =====
		function showScrollbarTemporarily() {
			if (!scrollbar) return;
			scrollbar.classList.add('is-active');
			clearTimeout(scrollbarHideTimer);
			scrollbarHideTimer = setTimeout(function () {
				scrollbar.classList.remove('is-active');
			}, SCROLLBAR_IDLE_DELAY);
		}

		// ===== Manual controls (desktop hover arrows) =====
		if (prevBtn) {
			prevBtn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				goTo(getIndex() - 1);
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				goTo(getIndex() + 1);
			});
		}

		if (scrollbar) {
			scrollbar.addEventListener('click', function (e) {
				const rect = scrollbar.getBoundingClientRect();
				const ratio = (e.clientX - rect.left) / rect.width;
				const targetIndex = Math.round(ratio * (count - 1));
				goTo(targetIndex);
			});
		}

		let scrollTimeout;
		track.addEventListener('scroll', function () {
			showScrollbarTemporarily();
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(updateUI, 50);
		}, { passive: true });

		if (window.ResizeObserver) {
			const ro = new ResizeObserver(function () {
				updateUI();
			});
			ro.observe(track);
		} else {
			window.addEventListener('resize', function () {
				clearTimeout(scrollTimeout);
				scrollTimeout = setTimeout(updateUI, 100);
			});
		}

		// ===== Autoplay behavior =====
		// Desktop: hover par start, mouse leave par stop
		slider.addEventListener('mouseenter', function () {
			if (!isMobile()) startAutoplay();
		});
		slider.addEventListener('mouseleave', function () {
			if (!isMobile()) stopAutoplay();
		});

		// Mobile: hamesha autoplay, lekin sirf jab slider viewport mein visible ho
		if (window.IntersectionObserver) {
			const io = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					isInView = entry.isIntersecting;
					if (isMobile()) {
						if (isInView) {
							startAutoplay();
						} else {
							stopAutoplay();
						}
					}
				});
			}, { threshold: 0.5 });
			io.observe(slider);
		} else if (isMobile()) {
			startAutoplay();
		}

		// User manually swipe/drag/touch kare to autoplay pause + scrollbar dikhao
		track.addEventListener('pointerdown', function () {
			stopAutoplay();
			showScrollbarTemporarily();
		});
		track.addEventListener('pointerup', function () {
			setTimeout(function () {
				if (isMobile() && isInView) {
					startAutoplay();
				}
			}, 500);
		});

		// Desktop hover par bhi scrollbar-jaisa indicator
		slider.addEventListener('mouseenter', function () {
			if (!isMobile()) showScrollbarTemporarily();
		});

		window.addEventListener('resize', function () {
			if (isMobile()) {
				if (isInView) startAutoplay();
			} else {
				stopAutoplay();
			}
		});

		updateUI();
	}

	function initAll() {
		document.querySelectorAll('[data-media-slider]').forEach(function (slider) {
			if (slider.dataset.sliderInit) return;
			slider.dataset.sliderInit = 'true';
			initSlider(slider);
		});
	}

	document.addEventListener('DOMContentLoaded', initAll);
	document.addEventListener('infiniscroll:loaded', initAll);
	document.body.addEventListener('cart:refresh', initAll);

	// Fallback: kisi bhi tarike se naya product-grid content DOM mein aaye, use auto-detect karo
	if (window.MutationObserver) {
		const gridObserver = new MutationObserver(function (mutations) {
			let shouldInit = false;
			mutations.forEach(function (m) {
				m.addedNodes.forEach(function (node) {
					if (node.nodeType !== 1) return;
					if (node.matches && node.matches('[data-media-slider]')) {
						shouldInit = true;
					} else if (node.querySelector && node.querySelector('[data-media-slider]')) {
						shouldInit = true;
					}
				});
			});
			if (shouldInit) initAll();
		});

		gridObserver.observe(document.body, { childList: true, subtree: true });
	}
})();